const ToastTypes = {
    SUCCESS: "success",
    ERROR: "error",
  };
  
  export default ToastTypes;
  